// React
import { createContext } from "react"

export const RowIndexContext = createContext<(index: number) => number>((_) => 0)